<script>
import InputTextarea from '../__components/InputTextarea.vue';
import MixinItem from '../__mixins/item';

export default {
  mixins: [MixinItem],
  components: {
    InputTextarea,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
  },
};
</script>
<template>
  <InputTextarea
    :autosize="module.autosize"
    :value="value"
    :placeholder="placeholder"
    :disabled="disabled"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
    @submit="$emit('submit', $event)"
  />
</template>
